import portalAxiosInstance from './portalAxiosInstance';

const PortalProjectService = {
    getProjects: () =>
        portalAxiosInstance.get('/api/portal/projects').then(r => r.data),

    getProject: (id) =>
        portalAxiosInstance.get(`/api/portal/projects/${id}`).then(r => r.data),

    getNotes: (id) =>
        portalAxiosInstance.get(`/api/portal/projects/${id}/notes`).then(r => r.data),

    addNote: (id, content) =>
        portalAxiosInstance.post(`/api/portal/projects/${id}/notes`, { content }).then(r => r.data),

    editNote: (id, noteId, content) =>
        portalAxiosInstance.put(`/api/portal/projects/${id}/notes/${noteId}`, { content }).then(r => r.data),

    deleteNote: (id, noteId) =>
        portalAxiosInstance.delete(`/api/portal/projects/${id}/notes/${noteId}`).then(r => r.data),
};

export default PortalProjectService;
